import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  setGlobalOverride,
  removeGlobalOverride,
  setOrgOverride,
  removeOrgOverride,
} from '../api/platformApi';
import { platformKeys } from './usePlatformOrganisations';

export function useSetGlobalOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ key, isEnabled }: { key: string; isEnabled: boolean }) =>
      setGlobalOverride(key, { isEnabled }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: platformKeys.all });
    },
  });
}

export function useRemoveGlobalOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ key }: { key: string }) => removeGlobalOverride(key),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: platformKeys.all });
    },
  });
}

export function useSetOrgOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      key,
      orgId,
      isEnabled,
    }: {
      key: string;
      orgId: string;
      isEnabled: boolean;
    }) => setOrgOverride(key, orgId, { isEnabled }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: platformKeys.all });
    },
  });
}

export function useRemoveOrgOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ key, orgId }: { key: string; orgId: string }) =>
      removeOrgOverride(key, orgId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: platformKeys.all });
    },
  });
}
